module.exports = __webpack_public_path__ + "img/call_ended.fde11e84.png";